import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import Loader from 'react-loader-spinner'
import { checkTranslation, imageAddress, translate } from "../../../utils/useful";
import moment from 'jalali-moment'
import HttpServices from "../../../utils/Http.services";
import MessengerCreateNew from "./MessengerCreateNew";
import MessageStatusView from "./boxes/MessageStatusView";
import { getBoundingClientRect } from "../../../utils/functions";
import Modal from "../../Modal";
import store from "../../../stores/storeConfig";
import { removeMessenger } from "../../../stores/actionsList";
import SelectApplet_ from "../../useful/SelectApplet_";
import SettingsMessenger from "../../header/SettingsMessenger";

class MessengerList extends Component {

    state = {
        data: [],
        headers: [
            { type: 'SelectInput', key: 'applet', information: { type: 'api', address: 'getMyFramesByType', filter: { features: 'Messenger' }, fields: { title: 'applet.name', value: 'applet._id' }, placeholder: '{{lang}}messenger.Select The Applet', required: true } },
        ],
        show: false,
        showContextMenu: false,
        xPos: "0",
        yPos: "0",
        MessengerContextMenu: [
            { icon: "/assets/icons/messenger/pin.svg", title: "{{lang}}messenger.Pin", key: 'pin' },
            { icon: "/assets/icons/messenger/select.svg", title: "{{lang}}messenger.Select", key: 'select' },
            { icon: "/assets/icons/messenger/trash.svg", title: "{{lang}}messenger.Delete", key: 'delete', color: "#FF3B30" },
        ],
        currentApplet: {},
        listSearch: '',
        filteredMessenger: [],
        filteredMessengers: [],
        skip: 0,
    }

    componentDidMount() {
        this.init()
        this.setState({ width: window.innerWidth })
        window.addEventListener('resize', this.updateWidth)
        document.addEventListener('click', () => {
            let contextMenu = this.state.contextMenu;
            if (contextMenu) {
                contextMenu.show = false;
                this.setState({
                    showContextMenu: false,
                    contextMenu: contextMenu
                })
            }
        })


        this.messengersList.addEventListener('scroll', this.handleScroll);


    }


    componentWillUnmount() {
        this.messengersList.removeEventListener('scroll', this.handleScroll);
    }



    componentDidUpdate(prevProps) {
        // console.log('prevProps', prevProps)
        if (this.props.page !== prevProps.page || this.props.user?.info?._id != prevProps.user?.info?._id) {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }
        // console.log('this.props.messengers.list1', this.props.messengers.list)
        if (JSON.stringify(this.props.messengers.list) != JSON.stringify(this.state.refData)) {
            // console.log('prevProps.listCount', prevProps.messengers?.list)
            this.setState({ refData: JSON.parse(JSON.stringify(this.props.messengers.list)) })
            this.filterMessengersList()
            // this.filterApplet(JSON.parse(JSON.stringify(this.props.messengers.list)))


        }

        if (this.props.scope !== prevProps.scope) {

            this.filterMessengersList(true)
            // this.fetchData()

        }
    }


    handleScroll = () => {

        const container = this.messengersList

        // console.log(container.scrollTop, container.clientHeight, container.scrollHeight)
        if (container.scrollTop + container.clientHeight >= (container.scrollHeight - 200)) {

            this.fetchData()
            // console.log("LOAD MORE")
        }
    }


    updateWidth = () => {
        this.setState({ width: window.innerWidth })
    }

    replyAction = (key) => {
        if (key == 'delete') {
            this.deletemessage.showModal()
        }
    }

    searchHub = (event) => {
        this.setState({ listSearch: event.target.value }, () => {
            let messengerList = this.state.messengerList
            let filteredMessengers = messengerList?.filter((e) => {
                // let found = false
                // e.users.map((prop) => {
                //     if (prop?.hub?.username?.toLowerCase()?.includes(this.state.listSearch.toLowerCase())) {
                //         found = true
                //     }
                // })
                // return found == true
                return e['**name']?.toLowerCase()?.includes(this.state.listSearch.toLowerCase())
            })
            if (event.length == 0) {
                filteredMessengers = []
            }
            this.setState({ filteredMessengers })
        })
    }

    deleteMessageAction = (item) => {
        this.deletemessage.hideModal()
        HttpServices.request('deleteMessenger', { messenger: item._id, hub: this.state.myId }, (fetchResult, fetchError) => {
            let messengers = fetchResult.info
            if (!Array.isArray(messengers)) {
                messengers = [messengers]
            }
            store.dispatch(removeMessenger(messengers, this.state.myId))
            this.props.setData('messenger', null, 'Messenger')
        })
    }

    hideModal = () => {
        this.setState({ currentItem: null }, () => {
            this.deletemessage.hideModal()
        })
    }



    translateStatus = (status) => {
        let newStatus
        switch (status) {
            case 0:
                newStatus = 'not active'
                break;

            case 1:
                newStatus = 'pending'
                break;

            case 2:
                newStatus = 'waiting for awnser'
                break;

            case 3:
                newStatus = 'awnsered'
                break;

            case 4:
                newStatus = 'done'
                break;

            default:
                break;
        }
        return newStatus
    }

    // setCurrentApplet = (key, value) => {
    //     this.setState({ [key]: value }, () => {
    //         this.props.selectApplet(this.state.currentApplet)
    //         this.filterSelectApplet(this.state.currentApplet)
    //     })
    // }

    // filterSelectApplet = (current) => {
    //     let messengerList = []
    //     let messengers = this.props.messengers.list
    //     let filteredMessenger = this.state.filteredMessenger
    //     if (current == null) {
    //         messengerList = messengers
    //         filteredMessenger = messengers
    //     }
    //     else {
    //         filteredMessenger = []
    //         messengers.forEach((element) => {
    //             let found = false
    //             element.applets?.forEach((prop) => {
    //                 if (prop.applet == current._id) {
    //                     found = true
    //                 }
    //             })
    //             if (found) {
    //                 messengerList.push(element)
    //                 filteredMessenger.push(element)
    //             }
    //         });
    //     }
    //     // this.props.setMessenger(null)
    //     this.setState({ messengerList, filteredMessenger })
    // }

    init() {
        // if (this.props.page) {
        // let myId = this.props.isApplet ? (this.props.variables.appletHub._id ?? this.props.variables.appletHub) : this.props.user?.info?._id
        let myId = this.props.user?.info?._id
        if (myId) {
            this.setState({ myId, skip: 0, data: [], currentPage: 0, totalCount: null, filter: null }, () => {
                // this.fetchData(true)
            })
        }

        this.filterMessengersList()
        // }
    }

    fetchData = (getCount) => {

        // console.log("fetchData", !this.state.isLoadingMessengers, !this.state.noMoreMessengers)
        // this.props.actions.changeSetting('socketStatus', "updading")
        if (!this.state.isLoadingMessengers && !this.state.noMoreMessengers) {
            this.setState({ isLoadingData: true })
            // let body = this.props.page?.filter ?? {}
            let body = {}

            // console.log("fetchData")

            // body.user = this.state.myId

            let scope = this.props.scope ?? {}
            let limit = 15

            // console.log("Scope", scope)

            if (scope.type && scope.item) {
                body[scope.type] = scope.item?._id ?? scope.item
            }

            // console.log("fetchData 1")


            if (this.props.isApplet && this.props.page?._id) {
                // body.applet = this.props.variables?.applet._id
                body.frame = this.props.page?._id
            }
            let skip = this.state.skip//(Array.isArray(this.state.filteredMessengers)) ? this.state.filteredMessengers.filter((messenger) => { return !messenger.parent }).length : 0// this.state.filteredMessengers?.length ?? 0


            // console.log("fetchData 2")

            // console.log(skip)
            body.skip = skip * limit
            // console.log("fetchData", body)
            // let page = this.props.page
            // body.page = page.key
            // body.limit = this.state.limit
            // body.skip = this.state.currentPage
            // body.filter = this.state.filter ?? {}
            // for (const [key, value] of Object.entries(body)) {
            //     if (/\{\{(.*?)\}\}/.test(value)) {
            //         if (this.props.variables) {
            //             body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
            //         }
            //     }
            // }
            // if (this.state.totalCount == null || getCount) {
            //     body.getCount = true
            // }
            this.setState({ isLoadingMessengers: true })
            let address = 'getMyMessengers'


            if (!this.props.adminView) {

                address = 'getUserPerspectiveConversations'
                if (!body.frame) {
                    return
                }

            }

            // console.log('firstbody', address, body)

            HttpServices.request(address, body, (fetchResult, fetchError) => {

                // console.log(fetchResult, fetchError)

                // this.props.actions.changeSetting('socketStatus', false)
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    this.setState({ isLoadingMessengers: false })

                    return
                }

                this.setState({ skip: (this.state.skip + 1) })
                // fetchResult.info.sort((a, b) => b.uDate > a.uDate)
                // console.log('startTP',fetchResult)

                if (fetchResult.info?.length < limit) {
                    // console.log("END")
                    this.setState({ noMoreMessengers: true })

                } else {
                    this.setState({ noMoreMessengers: false })
                }
                if (fetchResult.info?.length > 0) {

                    this.setState({ data: [] }, () => {
                        let messengerList = []
                        let messengers = fetchResult.info
                        let myId = this.state.myId

                        // messengers.forEach((messenger, index) => {
                        //     if (!messenger.parent) {
                        //         // let name = messenger.name
                        //         let name
                        //         let image = messenger.image
                        //         let allRefs = []
                        //         // let myId = ''
                        //         // messenger.interactiveUsers.forEach((user) => {
                        //         //     if (user.hub == this.state.myId) {
                        //         //         myId = user.refHub
                        //         //     }
                        //         // })
                        //         if (!name) {
                        //             if (messenger.type == 'support') {
                        //                 let isAdmin
                        //                 messenger.interactiveUsers.forEach(element => {
                        //                     // console.log('element---', element)
                        //                     // console.log('myId---', myId)
                        //                     if (element.hub?._id == myId && element.admin) {
                        //                         isAdmin = true
                        //                     }
                        //                 })
                        //                 if (isAdmin) {
                        //                     messenger.users?.forEach(element => {
                        //                         // console.log('element.hub', element.hub)
                        //                         if (element.hub && element.hub?._id != myId) {
                        //                             name = element.hub.fullname
                        //                         }
                        //                     })
                        //                 } else {
                        //                     name = messenger.name
                        //                 }
                        //             } else if (messenger.type == 'group') {
                        //                 name = messenger.name

                        //             }
                        //             else {
                        //                 if (Array.isArray(messenger.interactiveUsers)) {
                        //                     messenger.interactiveUsers.forEach(element => {
                        //                         if (element.hub?._id == myId) {
                        //                             let refs = element.refs


                        //                             if (Array.isArray(refs) && Array.isArray(messenger.users)) {
                        //                                 // let ref = refs[0]?.hub
                        //                                 // let finalUser 

                        //                                 for (let j = 0; j < refs.length; j++) {
                        //                                     const ref = refs[j].hub;

                        //                                     for (let r = 0; r < messenger.users.length; r++) {
                        //                                         const rUser = messenger.users[r].hub;
                        //                                         if ((rUser?._id ?? rUser) != (ref?._id ?? ref) && ((rUser?._id ?? rUser) != myId)) {

                        //                                             name = rUser?.fullname
                        //                                             image = rUser?.image

                        //                                         }
                        //                                     }

                        //                                     if ((myId) != (ref?._id ?? ref)) {

                        //                                         allRefs.push(refs[j])

                        //                                     }

                        //                                 }


                        //                             }

                        //                         }
                        //                     })
                        //                 }
                        //             }
                        //         }

                        //         if (Array.isArray(messenger.frames)) {
                        //             messenger.frames.forEach(frame => {
                        //                 // console.log("frame", frame.hub, myId)
                        //                 if ((frame.hub?._id ?? frame.hub) == myId) {

                        //                     // console.log("ff", frame)

                        //                     messengers[index]["**frame"] = frame.frame

                        //                 }
                        //             })
                        //         }


                        //         if (Array.isArray(messenger.applets)) {
                        //             messenger.applets.forEach(applet => {
                        //                 // console.log("applet",myId, applet)
                        //                 if ((applet.hub?._id ?? applet.hub) == myId) {

                        //                     messengers[index]["**applet"] = applet.applet

                        //                 }
                        //             })
                        //         }

                        //         messengers[index]["**name"] = name
                        //         messengers[index]["**image"] = image
                        //         messengers[index]["**refs"] = allRefs


                        //         messengerList.push(messenger)

                        //         // messengers[index]["**applet"] = name

                        //         // console.log('startTP3', messengers)
                        //     }
                        // })

                        // console.log('messengerList', messengers)

                        if (Array.isArray(messengers)) {
                            this.props.actions.addMessengers(messengers, false, myId)
                        }

                        // this.setState({ messengerList }, () => {

                        if (fetchResult.count != null) {
                            this.setState({ totalCount: fetchResult.count })
                        }


                        // this.setState({ isLoadingMessengers: false }, () => {
                        //     // this.handleScroll()
                        //     // setTimeout(() => {
                        //     //     this.filterMessengersList()
                        //     // }, 200);
                        // })
                        // })
                        // console.log('startTP4')
                        // setTimeout(() => {
                        //     this.filterApplet(this.props.messengers.list)
                        // }, 50);
                        // return
                        // console.log('getMyMessengers',body)
                        // messengers.forEach(messenger => {
                        this.props.actions.changeLastSeen(messengers, this.state.myId)
                        // console.log('firstsetNotificationCount',messenger._id,fetchResult.notifs)
                        this.props.actions.setNotificationCount(messengers, fetchResult.notifs)
                        // this.props.actions.setNotificationCount(messenger._id, fetchResult.notifs[messenger._id])
                        this.props.actions.appendMessages(messengers, fetchResult.messages)
                        // });
                        // this.setState({ data: messengers })
                    })
                }

                // console.log("HEREEE")
                this.setState({ isLoadingMessengers: false }, () => { })

            })

        }
    }



    filterMessengersList = (resetEnd) => {

        // console.log("filterMessengersList", this.state.myId)
        let filteredMessengers = []
        let scope = this.props.scope

        // console.log("scope", scope)

        if (scope && scope.item && scope.type && Array.isArray(this.props.messengers.list)) {

            let scopeValue = scope.item
            scopeValue = scopeValue?._id ?? scopeValue

            if (!this.props.adminView) {
                scopeValue = this.props.frame?._id
            }
            let type = scope.type
            // if (type == 'hub') {
            //     type = "refHub"
            // }

            // console.log("filterMessengersList", this.props.messengers.list)

            filteredMessengers = this.props.messengers.list.filter((messenger) => {



                if (!this.props.adminView) {


                    if (Array.isArray(messenger.interactiveUsers) && Array.isArray(messenger.frames)) {

                        let frameFound = false
                        let frameId = this.props.frame?._id


                        for (let i = 0; i < messenger.frames.length; i++) {
                            const frame = messenger.frames[i]?.frame

                            if ((frame?._id ?? frame) == frameId) {

                                frameFound = true

                            }
                        }

                        // console.log("frameFound",frameFound,frameId,messenger.frames)

                        if (frameFound) {

                            for (let i = 0; i < messenger.interactiveUsers.length; i++) {
                                const interactiveUser = messenger.interactiveUsers[i];
                                let mHub = interactiveUser.hub
                                mHub = mHub?._id ?? mHub
                                if (mHub == this.state.myId) {
                                    // let isNotAdmin = true
                                    if (Array.isArray(interactiveUser.refs)) {
                                        for (let j = 0; j < interactiveUser.refs.length; j++) {
                                            const ref = interactiveUser.refs[j];

                                            if (!ref.admin) {
                                                return true
                                            }
                                            // let value = ref[type]
                                            // value = value?._id ?? value

                                            // // console.log(type, value, scopeValue, this.state.myId, messenger)

                                            // if (value == scopeValue) {
                                            //     return true
                                            // }
                                        }
                                    }


                                }
                            }


                        }

                    }

                } else {

                    if (Array.isArray(messenger.interactiveUsers)) {

                        for (let i = 0; i < messenger.interactiveUsers.length; i++) {
                            const interactiveUser = messenger.interactiveUsers[i];
                            let mHub = interactiveUser.hub
                            mHub = mHub?._id ?? mHub
                            if (mHub == this.state.myId) {

                                if (Array.isArray(interactiveUser.refs)) {
                                    for (let j = 0; j < interactiveUser.refs.length; j++) {
                                        const ref = interactiveUser.refs[j];

                                        let value = ref[type]
                                        value = value?._id ?? value

                                        // console.log(type, value, scopeValue, this.state.myId, messenger)

                                        if (value == scopeValue) {
                                            return true
                                        }
                                    }
                                }


                            }
                        }
                    }
                }
            })

        } else {

            filteredMessengers = this.props.messengers.list ?? []

        }

        filteredMessengers = filteredMessengers.sort((a, b) => new Date(b.uDate).getTime() - new Date(a.uDate).getTime())
        // console.log("filteredMessengers", JSON.parse(JSON.stringify(filteredMessengers)))

        this.setState({ filteredMessengers }, () => {

            if (resetEnd) {
                this.setState({ noMoreMessengers: false }, () => {
                    this.handleScroll()
                })
            } else {
                this.handleScroll()
            }
        })

    }

    timeToText(time) {
        let timeMoment = moment(time)
        let nowMoment = moment(new Date())
        let text = timeMoment.format('HH:mm')
        if (timeMoment.startOf('day').valueOf() != nowMoment.startOf('day').valueOf()) {
            if (timeMoment.startOf('day').valueOf() == nowMoment.subtract(1, 'days').startOf('day').valueOf()) {
                text = '{{lang}}Yesterday'
            } else {
                text = timeMoment.format('YY/MM/DD')
            }
        }
        return text
    }

    liveChange = (data, initData, key, value, extra, full) => {
        this.props.selectApplet(value)
    }

    filterApplet = (messengers) => {
        // console.log('tp1messengers1', messengers)
        // console.log('this.props.isApplet', this.props.isApplet)
        let messengerList = []
        if (this.props.isApplet) {

            for (let i = 0; i < messengers.length; i++) {
                // console.log('messengers[i]', messengers[i])
                let check = false
                for (let x = 0; x < messengers[i].frames?.length; x++) {
                    if ((messengers[i].frames[x].frame?._id ?? messengers[i].frames[x].frame) == this.props.page?._id) {
                        // console.log('messengers[i]first', messengers[i])
                        check = true
                    }
                }
                if (check == true) {
                    let newMessenger = JSON.parse(JSON.stringify(messengers[i]))
                    let name
                    let myId = this.state.myId
                    // let myId = ''
                    // messenger.interactiveUsers.forEach((user) => {
                    //     if (user.hub == this.state.myId) {
                    //         myId = user.refHub
                    //     }
                    // })
                    if (!name) {
                        if (newMessenger.type == 'support') {
                            let isAdmin
                            newMessenger.interactiveUsers.forEach(element => {
                                // console.log('element---', element)
                                // console.log('myId---', myId)
                                if (element.hub?._id == myId && element.admin) {
                                    // console.log('isadminuser', isAdmin)
                                    isAdmin = true
                                }
                            })
                            if (isAdmin) {
                                newMessenger.users?.forEach(element => {
                                    if (element.hub?._id != myId) {
                                        name = element.hub.fullname
                                    }
                                })
                            } else {
                                // console.log('newMessengerNAMW', newMessenger.name)
                                name = newMessenger.name
                            }
                        } else if (newMessenger.type == 'group') {
                            name = newMessenger.name
                        } else {
                            newMessenger.interactiveUsers.forEach(element => {
                                if (element.hub?._id != myId) {
                                    name = element?.refHub?.fullname
                                }
                            })
                        }
                    }
                    // console.log('nameisuuu', name)
                    newMessenger["**name"] = name

                    messengerList.push(newMessenger)
                }
            }
        }
        else {
            messengerList = messengers
        }
        let filteredMessenger = messengerList
        // console.log('filterapplet', filteredMessenger)
        this.setState({ messengerList, filteredMessenger }, () => {
            // console.log('startTPEnded')
        })
    }

    onRightClickItem = (event, item, type) => {
        let currentItem = item;
        let corner = getBoundingClientRect(this.cornerDiv)
        this.setState({
            showContextMenu: true,
            contextMenu: {
                xPos: event.pageX - corner.left,
                yPos: event.pageY - corner.top,
                show: true,
                view: type
            },
            currentItem
        })
    }

    openCreateNew = () => {
        // if (this.state.currentApplet == {} || this.props.currentApplet == null) {
        //     this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.Select applet first', description: '' })
        //     this.selectApplet.appletView.showView()
        // } else {
        this.MessengerCreateNew.openSidebar()
        // }
    }

    render() {



        // console.log("this.state.filteredMessenger",this.state.filteredMessenger)
        return (
            <div className="w-100 p-0 m-0 h-100 " style={{ borderLeft: '1px solid #f2f2f2', borderRight: '1px solid #f2f2f2' }}>
                {/* <div className="col-12 col-md-5 col-lg-4 mb-5 mt-4 w-100 p-0"> */}
                <div className="h-100 w-100 d-flex flex-column">
                    <div className="pt-2" style={{ backgroundColor: "#fff", zIndex: "1", borderBottom: "1px solid #f6f6f6" }}>
                        {/* <div className='flexcb pb-3 px-2 pt-3'>
                            <div className="flexc w-100">
                                {this.props.applet ? (
                                    <div className="position-relative">
                                        <img src={imageAddress(this.props.applet.hub?.image, 'applet')} style={{ width: '40px', height: '40px', borderRadius: 40, objectFit: 'cover', objectFit: "cover" }} />
                                        <div className="position-absolute br-50 flexcc" style={this.props.language == 'fa' ? { backgroundColor: '#fff', bottom: 0, left: 65, width: 25, height: 25, border: '1px solid #eee' } : { backgroundColor: '#fff', bottom: 0, right: -8, width: 25, height: 25, border: '1px solid #eee' }}>
                                            <img className="" src={('/assets/icons/portals/chat (2).png')} style={{ width: 22, height: 22, borderRadius: '50%', border: '0px solid #eee' }} />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="position-relative">
                                        <img src="/assets/icons/portals/folder2.svg" height={40} />
                                    </div>
                                )}
                                <div className='mld-2'>
                                    {this.props.applet ?
                                        <p className="m-0 font-size-14 weight-500 mb-0 pld-2" style={{ color: "#444" }}>{checkTranslation(this.props.applet?.name)}</p>
                                        :
                                        <p className="m-0 font-size-16 weight-700 mb-0" style={{ color: "#444" }}>{translate('messenger.Messenger')}</p>
                                    }
                                </div>
                            </div>
                            {this.props.isApplet && (
                                <SettingsMessenger showHeader={this.props.showHeader} width={this.props.width} functionsHandler={this.props.functionsHandler} language={this.props.language} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} colors={this.props.colors} />
                            )}
                            {(this.props.page?.mode != 'support') && (
                                <button className="flexcc br-50 bg-gray-06" onClick={() => this.openCreateNew()}>
                                    <img className=" " src="/assets/icons/messenger/plus-black.svg" alt="" width="24" />
                                </button>
                            )}
                        </div> */}
                        {/* {!this.props.isApplet && (
                            <div>
                                <FormViewer liveChange={this.liveChange} ref={el => this.form = el} headers={this.state.headers} inputClass={"modern-input"} />
                            </div>
                        )} */}
                        {/* {!this.props.isApplet && (
                            <div className="mx-2 mb-2">
                                <SelectApplet_ ref={el => this.selectApplet = el} type='messenger' setData={this.setCurrentApplet} language={this.props.settings.language} colors={this.props.colors} />
                            </div>
                        )} */}
                        <div className="px-2 w-100 mb-2 flexc">
                            <div className="flex-1 bg-gray-06" style={{ borderRadius: 10 }}>
                                <input className="py-2 px-2 w-100 change-placeHolder" value={this.state.listSearch} onChange={(e) => this.searchHub(e)} placeholder={translate('messenger.Search')} style={{ backgroundColor: 'transparent', border: 'none', color: "#444" }} />
                            </div>

                            {(this.props.page?.mode != 'support') && (
                                <button className="flexcc br-50 bg-gray-06 mld-3" onClick={() => this.openCreateNew()}>
                                    <img className=" " src="/assets/icons/messenger/plus-black.svg" alt="" width="24" />
                                </button>
                            )}

                        </div>
                    </div>
                    {/* <button onClick={() => this.openFilterModal()} className="flexc px-4 mrd-3 w-100 py-2" style={{ flex: 1, color: '#000', backgroundColor: '#00000007' }}>
                        <img className=" " src="/images/search.svg" alt="" width="16px" />
                        <span className="text-small mx-1  text-bold" >Filter</span>
                    </button> */}
                    {/* <div className="flexc px-2">
                        {this.state.filter && Object.values(this.state.filter).map((prop, index) => {
                            if ((prop.key != 'location') && (prop.key != 'location1')) {
                                return (
                                    <div className="flexcc mrd-2 mb-1 mt-2" key={prop.key} style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '4px 10px' }}>
                                        <button onClick={() => this.removeFilter(prop, null)} className="p-0 m-0 flexcc">
                                            <img className="mrd-2 opacity-7" src="/images/close.svg" alt="" width="10px" />
                                        </button>
                                        <p className="text-smaller">{checkTranslation(this.filterLabelCreator(prop))}</p>
                                    </div>
                                )
                            } else {
                                return (
                                    <div className="flexcc mrd-2 mb-1 mt-2" key={prop.key} style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '4px 10px' }}>
                                        <button onClick={() => this.removeFilter(prop, null)} className="p-0 m-0 flexcc">
                                            <img className="mrd-2 opacity-7" src="/images/close.svg" alt="" width="10px" />
                                        </button>
                                        <p className="text-smaller">LAT {prop.value.lat} - LNG {prop.value.lng} {prop.value.radius ? (" - Radius " + priceStandardView(prop.value.radius) + ' meters') : ""} </p>
                                    </div>
                                )
                            }
                        }
                        )}  
                    </div> */}
                    {/* {this.state.data.map((item, index) => { */}
                    {/* {console.log('messengersmessengersmessengers', this.props.messengers)} */}
                    <div ref={el => this.messengersList = el} className="w-100 scroll-no-scrollbar pb-2 flex-1" style={{ height: this.props.isApplet ? 'calc(100% - 106.4px)' : 'calc(100% - 160.8px)' }}>
                        {/* {console.log(this.state.filteredMessengers)} */}
                        {(!this.props.adminView && this.props.frame?.mode == 'support') && (
                            <button onClick={this.props.startNewTicket} className="text-start text-link px-3 py-3">
                                <p>{translate("Start a new conversation")}</p>
                            </button>
                        )}
                        {(Array.isArray(this.state.filteredMessengers) &&
                            this.state.filteredMessengers?.map((item, index) => {
                                if (!item.parent) {
                                    // let parents = this.props.messengers.list.filter((e) => e.parent == item._id).map(obj => obj._id);

                                    let notifcount = this.props.inbox?.messengers?.[item._id]?.totalCount
                                    // console.log("notifcount",notifcount)
                                    // console.log("this.props.inbox?.messengers",this.props.inbox?.messengers)

                                    // let notifcount = this.props.messengers?.notifications[item._id] ?? 0
                                    // parents.map((element) => {
                                    //     notifcount += (this.props.messengers?.notifications[element] ?? 0)
                                    // })
                                    // let lastMsg = this.props.messengers?.object[item._id] && this.props.messengers?.object[item._id]['lastMsg']
                                    let lastMsg = this.props.messengers?.object?.[item._id]?.['lastMsg']
                                    let topiclastMsg = this.props.messengers?.object?.[item._id]?.['topiclastMsg']

                                    if ((topiclastMsg?.cDate ? new Date(topiclastMsg?.cDate).getTime() : 0) > (lastMsg?.cDate ? new Date(lastMsg?.cDate).getTime() : 0)) {

                                        lastMsg = JSON.parse(JSON.stringify(topiclastMsg))
                                    }

                                    // console.log(lastMsg)


                                    let systemInfo = lastMsg?.systemInfo?.name + ' ' + translate(lastMsg?.systemInfo?.type)
                                    let text = lastMsg?.text
                                    let time = lastMsg?.cDate
                                    let name = item["**name"]
                                    // console.log('itempp',item)
                                    let image = item["**image"]
                                    let frame = item["**frame"]
                                    let applet = item["**applet"]


                                    if (this.props.page?._id && item["**info"]) {


                                        if (item["**info"][this.props.page?._id]) {
                                            name = item["**info"][this.props.page?._id]?.name
                                            image = item["**info"][this.props.page?._id]?.image
                                            applet = item["**info"][this.props.page?._id]?.applet
                                            frame = item["**info"][this.props.page?._id]?.frame
                                        }

                                        if (!this.props.adminView && item["**userInfo"] && item["**userInfo"][this.props.frame?._id]) {
                                            name = item["**userInfo"][this.props.frame?._id]?.name
                                            image = item["**userInfo"][this.props.frame?._id]?.image
                                            applet = item["**userInfo"][this.props.page?._id]?.applet
                                            frame = item["**userInfo"][this.props.page?._id]?.frame
                                        }

                                    }
                                    // console.log('item.users',item)
                                    // if (item?.type == 'group' || item?.type == 'support') {
                                    //     image = item?.image
                                    // }
                                    // else {
                                    //     // console.log('item.users',item.users)
                                    //     item.users?.forEach(element => {
                                    //         if (element?.hub?._id != this.state.myId) {
                                    //             image = element.hub?.image
                                    //         }
                                    //     })
                                    // }
                                    let deafultImage = item?.type == 'group' ? 'group' : 'profile'
                                    return (
                                        <div key={item._id} className="single-ticket py-2 px-2 flexc bb-gray-messenger-list" style={{ cursor: 'pointer', backgroundColor: this.props.messenger?._id == item._id ? '#f6f6f6' : '', }} onClick={() => this.props.openMessenger(item)}>
                                            <div ref={el => this.cornerDiv = el} style={{ position: 'fixed', top: 0, left: 0, width: 1, height: 1 }}></div>
                                            <div className='w-100 flexc' style={{ alignItems: 'flex-start' }} onContextMenu={(event) => { event.stopPropagation(); event.preventDefault(); this.onRightClickItem(event, item) }}>
                                                <div className="position-relative">
                                                    <div className="flexcc position-relative" style={{}}>
                                                        <img src={imageAddress(image, deafultImage, 'thumb')} style={{ width: 40, height: 40, borderRadius: 40, objectFit: 'cover' }} alt="" />

                                                        {((frame && !this.props.isApplet) && item['**refs']?.length > 0) && (
                                                            <>
                                                                {item['**refs'].map((ref, i) => {
                                                                    return (
                                                                        <div key={ref._id} className=" flexcc position-absolute" style={{ top: 21, left: 21 }}>
                                                                            <img src={imageAddress(ref?.hub?.image, 'hub', 'thumb')} style={{ width: 22, height: 22, borderRadius: 16, objectFit: 'cover',border:'1px solid #eee' }} alt="" />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </>
                                                        )}
                                                    </div>


                                                </div>
                                                <div className="px-2" style={{ width: 'calc(100% - 34px)' }}>

                                                    {((frame && !this.props.isApplet) && item['**refs']?.length > 0) && (
                                                        <>
                                                            {item['**refs'].map((ref, i) => {
                                                                return (
                                                                    <div key={ref._id} className=" flexcc" style={{}}>
                                                                        {/* <p className="font-size-11 text-semibold  mrd-1">{translate("Behalf")}:</p> */}
                                                                        {/* <img src={imageAddress(ref?.hub?.image, 'hub', 'thumb')} style={{ width: 16, height: 16, borderRadius: 16, objectFit: 'cover' }} alt="" /> */}
                                                                        <p className="font-size-11 text-semibold w-100 mld-1" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden',color:'#777' }}>{ref?.hub?.fullname}</p>
                                                                    </div>
                                                                )
                                                            })}
                                                        </>
                                                    )}

                                                    <div className="flexcb w-100">
                                                        <p className="mb-0 text-bold prd-2" style={{ fontSize: 14, fontWeight: 500, color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTranslation(name)}</p>
                                                        <p className="mb-0 weight-300" style={{ fontSize: 10, color: '#999' }}>{checkTranslation(this.timeToText(time))}</p>
                                                    </div>

                                                    {/* {console.log(item['**refs'])} */}
                                                    {/* {((frame && !this.props.isApplet) && item['**refs']?.length > 0) && (
                                                        <>
                                                            {item['**refs'].map((ref, i) => {
                                                                return (
                                                                    <div key={ref._id} className=" flexcc" style={{}}>
                                                                        <p className="font-size-11 text-semibold  mrd-1">{translate("Behalf")}:</p>
                                                                        <img src={imageAddress(ref?.hub?.image, 'hub', 'thumb')} style={{ width: 16, height: 16, borderRadius: 16, objectFit: 'cover' }} alt="" />
                                                                        <p className="font-size-11 text-semibold w-100 mld-1" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{ref?.hub?.fullname}</p>
                                                                    </div>
                                                                )
                                                            })}
                                                        </>
                                                    )} */}


                                                    {(frame && !this.props.isApplet) && (
                                                        <div className="flex-1">
                                                            <p className="text-smallest color-gray-2 w-100" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{checkTranslation(frame?.name)}{item["**applet"]?.name ? ` - ${checkTranslation(applet?.name)}` : ''}</p>
                                                        </div>
                                                    )}



                                                    <div className="flexcb w-100">
                                                        <div className="flexc w-100 mt-1">
                                                            {/* {item["lastMsg"]?.sender}
                                                                {this.state.myId} */}
                                                            {/* {item['**refs'].length} */}

                                                            {item["lastMsg"]?.sender == this.state.myId && (
                                                                <div className="mrd-1">
                                                                    {/* {console.log('item["lastMsg"]',item["lastMsg"],this.state.messengerList)} */}
                                                                    <MessageStatusView status={item["lastMsg"]?.status} colors={this.props.colors} />
                                                                    {/* {(item["lastMsg"].status == 0 || item["lastMsg"].status == null) && (
                                                                            <img src="/assets/icons/applets/messenger/clock.png" width={10} style={{ opacity: 0.5 }} />
                                                                        )}
                                                                        {(item["lastMsg"].status == 1) && (
                                                                            <img src="/assets/icons/applets/messenger/sent.png" style={{ opacity: 0.5, }} />
                                                                        )}
                                                                        {(item["lastMsg"].status == 2) && (
                                                                            <img src="/assets/icons/applets/messenger/read.png" width={10} />
                                                                        )} */}
                                                                </div>
                                                            )}
                                                            {(text && !lastMsg?.file) && (lastMsg?.trashed == false) ? (
                                                                <>
                                                                    {/* {console.log('lastMsgsss',lastMsg,item)} */}
                                                                    {this.props.messengers.object[item._id]?.activity?.isTyping?.length > 0 ? (
                                                                        <p style={{ fontSize: 12, color: '#0085ff' }}>{translate('messenger.is typing')}</p>
                                                                    ) : (
                                                                        <p className="" style={{ color: '#777', fontSize: 12, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: "140px" }}>{lastMsg.topicName ? (lastMsg.topicName + ': ' + text) : text}</p>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div>
                                                                    {lastMsg?.trashed == true ? (
                                                                        <p className="w-100" style={{ color: '#777', fontSize: 10, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: "140px" }}>{translate('messenger.This message was deleted')}</p>
                                                                    ) : (
                                                                        <>

                                                                            {lastMsg?.voice && (
                                                                                <div className="flexcc">
                                                                                    <img className="mrd-1" src={'/assets/icons/messenger/mic-gray.svg'} height={18} />
                                                                                    <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.Voice')}</p>
                                                                                </div>
                                                                            )}
                                                                            {lastMsg?.file && (
                                                                                <div className="flexcc">
                                                                                    <img className="mrd-1" src={'/assets/icons/messenger/doc-gray.svg'} height={18} />
                                                                                    <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.File')}</p>
                                                                                </div>
                                                                            )}
                                                                            {lastMsg?.video && (
                                                                                <div className="flexcc">
                                                                                    <img className="mrd-1" src={'/assets/icons/messenger/play-gray.svg'} height={18} />
                                                                                    <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.Video')}</p>
                                                                                </div>
                                                                            )}
                                                                            {lastMsg?.image && (
                                                                                <div className="flexcc">
                                                                                    <img className="mrd-1" src={'/assets/icons/messenger/pic-gray.svg'} height={18} />
                                                                                    <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.Image')}</p>
                                                                                </div>
                                                                            )}
                                                                            {lastMsg?.systemInfo && (
                                                                                <div className="flexcc">
                                                                                    <img className="mrd-1" src={'/assets/icons/messenger/systeminfo.svg'} height={18} />
                                                                                    <p className="" style={{ color: '#777', fontSize: 12, maxWidth: '140px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{checkTranslation(systemInfo)}</p>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                        {notifcount ? (

                                                            <div className='white flexcc px-1' style={{ borderRadius: 20, lineHeight: 1, minWidth: "20px", minHeight: "20px", backgroundColor: '#0085ff', right: 0 }}>
                                                                <span className='text-smaller'>{checkTranslation(notifcount)}</span>
                                                            </div>

                                                        ) : <></>}
                                                    </div>
                                                    {/* {console.log('this.props.messenger?.assignee', item.status !=0)} */}
                                                    {/* {console.log('this.props.messenger?.assignee', this.props.messenger?.assignee)} */}
                                                    {this.props.frame?.mode == 'support' && (
                                                        <div className="mt-1">
                                                            {(this.props.adminView && item?.assignee) &&
                                                                <div className="flexc " style={{ color: '#777', }}>
                                                                    <p className="font-size-11  weight-400">{translate('Assignee')}:&nbsp;</p>
                                                                    {item?.assignee?.hub?._id == this.state.myId ? (
                                                                        <>
                                                                            <div className="flex-1">
                                                                                <p className="font-size-11  weight-400" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{translate("Me")}</p>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <img className="mld-1 mrd-1" src={imageAddress(item?.assignee?.hub?.image, 'profile', 'thumb')} style={{ width: 16, height: 16, borderRadius: 16, objectFit: 'cover' }} alt="" />
                                                                            <div className="flex-1">
                                                                                <p className="font-size-11  weight-400" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{item?.assignee?.hub?.fullname}</p>
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                </div>
                                                            }
                                                            {/* {item.type && */}
                                                            <div className="flexc mt-1">
                                                                {/* <p className="font-size-12 color-gray-2 weight-400">{translate('Status')} :&nbsp;</p> */}
                                                                <p className="font-size-12 main-c2 weight-500 px-2 py-1 br-20 text-capitalize" style={{ backgroundColor: '#ee505030' }}>{this.translateStatus(item?.status)}</p>
                                                            </div>
                                                        </div>

                                                    )}
                                                    {/* } */}
                                                    {/* <p className="ticket-desc">{item.description?.substr(0, 70)}{item.description?.length > 70 ? ' ...' : ''} </p> */}
                                                    {/* <p className="ticket-date">{moment(item.uDate).format("MMM YYYY, DD HH:mm")}</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        )}

                        {(!this.state.isLoadingMessengers && this.state.filteredMessengers?.length == 0) && (
                            <div className="px-3 w=100 h-100 flexcc flex-column">
                                <img src='/assets/icons/portals/folder2.svg' width={50} style={{ filter: 'grayscale(1)', opacity: 0.5 }} alt="" />
                                {/* <img src="/assets/no-contact.svg" height={150} /> */}
                                <p className="text-center text-small text-bold main-c4 mt-2" style={{}}>{translate('messenger.No Message is available')}</p>
                                <p className="text-center text-smaller main-c7 mt-1" style={{}}>{translate('messenger.You can find users and hubs and start communication throught chat with them')}</p>
                            </div>
                        )}


                        {this.state.isLoadingMessengers && (
                            <div className="flexcc w-100 mt-2">
                                <Loader
                                    type="ThreeDots"
                                    color="#789"
                                    height="40"
                                    width="40"
                                />
                            </div>
                        )}
                    </div>
                    {this.state.showContextMenu && (
                        <div style={{ position: "fixed", top: this.state.contextMenu.yPos, left: this.state.contextMenu.xPos, zIndex: "100000" }}>
                            <div className='shadow-2 px-3 py-1 br-10' style={{ width: "150px", backgroundColor: "#fff", }}>
                                {this.state.MessengerContextMenu.map((prop, index) => {
                                    return (
                                        <button className='flexcb w-100 py-2 bb-gray-list' onClick={() => this.replyAction(prop.key)}>
                                            <p style={{ color: prop.color }}>{checkTranslation(prop.title)}</p>
                                            <img width={22} src={prop.icon} />
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                    {/* <Modal className="blur-bg-side" ref={el => this.deletemessage = el} maxWidth={400} style={{}}>
                        <div className='flexcc p-4 br-15 flex-column m-5' style={{ backgroundColor: "#fff" }}>
                            <p className='text-center'>Are you sure you want to Delete this Messenger?</p>
                            <div className='mt-3 flexc'>
                                <button className='px-3 py-2 br-10 mx-2 red-box-fill' style={{ width: "120px" }} onClick={() => this.deleteMessageAction(this.state.currentItem)}>
                                    <p className='font-size-14'>Yes</p>
                                </button>
                                <button className='px-3 py-2 br-10 mx-2' style={{ backgroundColor: "#eee", width: "120px" }} onClick={() => this.hideModal()}>
                                    <p className='font-size-14'>Cancel</p>
                                </button>
                            </div>
                        </div>
                    </Modal> */}
                    <Modal className="" ref={el => this.deletemessage = el} maxWidth={400} style={{}}>
                        <div className='flexcc p-4 br-15 flex-column m-5' style={{ backgroundColor: "#fff" }}>
                            <p className='font-size-16 text-center weight-500' style={{ color: "#222" }}>{translate('messenger.Delete Chat')}</p>
                            <p className='font-size-10 text-center mt-2' style={{ color: "#777" }}>{translate('messenger.If you delete this chat, you will no longer have access to the chats')}</p>
                            <div className='mt-4 flexc w-100'>
                                <button className='px-3 py-2 br-5 mx-2 w-100' style={{ backgroundColor: "#eee", width: "100%" }} onClick={() => this.hideModal()}>
                                    <p className='font-size-14 main-c5'>{translate('messenger.Cancel')}</p>
                                </button>
                                <button className='px-3 py-2 br-5 mx-2 red-box-fill w-100' style={{ width: "100%" }} onClick={() => this.deleteMessageAction(this.state.currentItem)}>
                                    <p className='font-size-14'>{translate('messenger.Delete')}</p>
                                </button>
                            </div>
                        </div>
                    </Modal>
                    {/* <div className="mt-3">
                        <Pagination currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} />
                    </div> */}
                </div>
                <MessengerCreateNew isDesktop={this.props.isDesktop} isApplet={this.props.isApplet} variables={this.props.variables} ref={el => this.MessengerCreateNew = el} width={this.props.width} openOne={this.props.openOne} myId={this.state.myId} setMessenger={this.props.setMessenger} setData={this.props.setData} openModal={this.props.openModal} language={this.props.settings.language} colors={this.props.colors} />
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessengerList);